import { memo } from 'react';
import { useTranslation } from 'react-i18next';

import { GiftOutlined } from '@ant-design/icons';

import cls from './founders-club-banner.module.css';

interface FoundersClubBannerProps {
    discountDurationMonths: number;
    discountPercent: number;
}

export const FoundersClubBanner = memo((props: FoundersClubBannerProps) => {
    const { discountDurationMonths, discountPercent } = props;
    const { t } = useTranslation('subscription');

    return (
        <div className={cls.root}>
            <GiftOutlined className={cls.icon} />
            <div className={cls.content}>
                <span className={cls.title}>
                    {t('migration.foundersClubTitle')}
                </span>
                <span className={cls.description}>
                    {t('migration.foundersClubBanner', {
                        discount: discountPercent,
                        months: discountDurationMonths,
                    })}
                </span>
            </div>
        </div>
    );
});

FoundersClubBanner.displayName = 'FoundersClubBanner';
